import { downloadFile } from './uploadHelper';

/**
 * Reads a File and returns its content as a base64-encoded string
 * (without the data URL prefix).
 */
export const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result as string;
      resolve(result.split(',')[1] ?? '');
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};

export const localDownloadFile = (blob: Blob, fileName: string) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

export const downloadFileByUrl = async (fileName: string, fileUrl: string) => {
  const abortController = new AbortController();
  const response = await downloadFile(abortController, fileUrl);
  const blob = await response.blob();
  localDownloadFile(blob, fileName);
};
